// Este codigo fue generado por Github Copilot Chat
import { Component, forwardRef, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AbstractControlValueAccessorComponent } from '../../helpers/abstract-control-value-accessor';

@Component({
  selector: 'app-input-text-area',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './input-text-area.component.html',
  styleUrls: ['./input-text-area.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputTextAreaComponent),
      multi: true
    }
  ]
})
export class InputTextAreaComponent extends AbstractControlValueAccessorComponent<string> {
  @Input() rows = 4;
}
// Este codigo fue generado por Github Copilot Chat
